module.exports = __webpack_public_path__ + "static/confirm-ff5bae7b7f1fdff4c150c30ea960e9d7.svg";